import { CLICK_CODE, isNotEmptyArray } from '@local/utils'

import FlickingArea from '@web/components/FlickingArea/FlickingArea'
import FlickingContentMoreButton from '@web/ui/components/FlickingContentMoreButton'
import { Section, SectionHeader, SectionContent } from '@web/ui/pages/home/components/Sections/Section'
import {
  BookingCardItemType,
  OrderCardItemType,
  TicketCardItemType,
} from '@web/ui/pages/home/components/Sections/UIUpComingSection'
import BookingCardItem from '@web/ui/pages/home/components/Sections/UIUpComingSection/components/BookingCardItem'
import OrderCardItem from '@web/ui/pages/home/components/Sections/UIUpComingSection/components/OrderCardItem'
import TicketCardItem from '@web/ui/pages/home/components/Sections/UIUpComingSection/components/TicketCardItem'

import styles from './UpcomingSection.module.scss'

interface Props {
  upcomingOrderItems: OrderCardItemType[]
  upcomingOrderCount: number
  upcomingOrderMore?: boolean
  upcomingBookingItems: BookingCardItemType[]
  upcomingBookingCount: number
  upcomingBookingMore?: boolean
  upcomingTrainTicketItems: TicketCardItemType[]
  upcomingTrainTicketCount: number
  upcomingTrainTicketMore?: boolean
  onClickReservationMore?: ({ anchor }: { anchor: boolean }) => void
  onClickOrderMore?: ({ anchor }: { anchor: boolean }) => void
  onClickTrainTicketMore?: ({ anchor }: { anchor: boolean }) => void
}

export default function UITimelineAllUpcomingSection({
  upcomingOrderItems,
  upcomingBookingItems,
  upcomingTrainTicketItems,
  upcomingOrderCount,
  upcomingBookingCount,
  upcomingTrainTicketCount,
  upcomingBookingMore,
  upcomingOrderMore,
  upcomingTrainTicketMore,
  onClickReservationMore,
  onClickOrderMore,
  onClickTrainTicketMore,
}: Props) {
  return (
    <>
      {isNotEmptyArray(upcomingOrderItems) && (
        <Section className={styles.upcoming_section} noMargin>
          <SectionHeader
            title="진행 중인 주문"
            count={upcomingOrderCount}
            clickHandler={() => onClickOrderMore?.({ anchor: false })}
          />
          <SectionContent>
            <FlickingArea className={styles.flicking_area} options={{ cameraTag: 'ul' }}>
              {upcomingOrderItems.map((item, index) => (
                <OrderCardItem
                  key={index}
                  item={item}
                  isFlicking
                  clickCodes={{
                    cardClick: CLICK_CODE['timelinepg.upcomingcardclick'],
                    directionIcon: CLICK_CODE['timelinepg.upcomingdirectionicon'],
                  }}
                />
              ))}
              {upcomingOrderMore && (
                <li>
                  <FlickingContentMoreButton
                    onClick={() => onClickOrderMore?.({ anchor: true })}
                    clickCode={CLICK_CODE['timelinepg.upcomingviewmore']}
                  />
                </li>
              )}
            </FlickingArea>
          </SectionContent>
        </Section>
      )}
      {isNotEmptyArray(upcomingTrainTicketItems) && (
        <Section className={styles.upcoming_section} noMargin>
          <SectionHeader
            title="예매한 승차권"
            count={upcomingTrainTicketCount}
            clickHandler={() => onClickTrainTicketMore?.({ anchor: false })}
          />
          <SectionContent>
            <FlickingArea className={styles.flicking_area} options={{ cameraTag: 'ul' }}>
              {/* 승차권 */}
              {upcomingTrainTicketItems.map((item, index) => (
                <TicketCardItem
                  key={index}
                  item={item}
                  isFlicking
                  clickCodes={{
                    cardClick: CLICK_CODE['timelinepg.upcomingcardclick'],
                    bookingDetails: CLICK_CODE['timelinepg.upcomingbookingdetails'],
                  }}
                />
              ))}
              {upcomingTrainTicketMore && (
                <li>
                  <FlickingContentMoreButton
                    onClick={() => onClickTrainTicketMore?.({ anchor: true })}
                    clickCode={CLICK_CODE['timelinepg.upcomingviewmore']}
                  />
                </li>
              )}
            </FlickingArea>
          </SectionContent>
        </Section>
      )}
      {isNotEmptyArray(upcomingBookingItems) && (
        <Section className={styles.upcoming_section} noMargin>
          <SectionHeader
            title="다가오는 예약"
            count={upcomingBookingCount}
            clickHandler={() => onClickReservationMore?.({ anchor: false })}
          />
          <SectionContent>
            <FlickingArea className={styles.flicking_area} options={{ cameraTag: 'ul' }}>
              {upcomingBookingItems.map((item, index) => (
                <BookingCardItem
                  key={index}
                  item={item}
                  isFlicking
                  clickCodes={{
                    cardClick: CLICK_CODE['timelinepg.upcomingcardclick'],
                    bookingDetails: CLICK_CODE['timelinepg.upcomingbookingdetails'],
                    direction: CLICK_CODE['timelinepg.upcomingdirection'],
                  }}
                />
              ))}
              {upcomingBookingMore && (
                <li>
                  <FlickingContentMoreButton
                    onClick={() => onClickReservationMore?.({ anchor: true })}
                    clickCode={CLICK_CODE['timelinepg.upcomingviewmore']}
                  />
                </li>
              )}
            </FlickingArea>
          </SectionContent>
        </Section>
      )}
    </>
  )
}
